const LoyaltyModule = () => import('./LoyaltyCouponModule.vue')
const CouponsStatistics = () => import('./views/CouponsStatistics.vue')
const CouponsIndex = () => import('./views/CouponsIndex.vue')

export const loyaltyCouponRoute = {
  path: '/loyalty',
  component: LoyaltyModule,
  meta: {
    title: 'LoyaltyCoupon',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: 'coupons-statistics',
      name: 'loyaltyCouponsStatistics',
      meta: {
        permission: 'loyalty_coupon.view',
      },
      component: CouponsStatistics,
    },
    {
      path: 'coupons',
      name: 'loyaltyCoupons',
      meta: {
        permission: 'loyalty_coupon.view_all',
      },
      component: CouponsIndex,
    },
  ],
}
